/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { Modal } from 'antd-mobile'
import { Button } from '@styles/button.style'
import { observer } from 'mobx-react'
import { PageBgStyle } from '@styles/base.style'
import useRootStore from '@store/useRootStore'
import { BubblePopupStyle } from '@styles/modal'
import { BettingListSelectorWrap } from '@views/Popup/MessageContentPopup/index.style'
import BettingHistoryBg from '@assets/images/bg/betting-history-bg.png'
import BettingHistoryTab from '@views/BettingHistory/BettingHistoryTab'
import { FROM_VIEW_TYPE } from '@v2/constants/common'

const BubbleBetListPopup: React.FC = () => {

  const { globalStore, bettingHistoryStore } = useRootStore()
  const { visibleBubbleBetList } = globalStore

  // full-modal className 을 붙이기 위해.
  const isFullModal = true

  const onCloseHandler = () => {
    globalStore.setVisibleBubbleBetList(false)
  }

  bettingHistoryStore.resetSelectedBettingHistory(FROM_VIEW_TYPE.BUBBLE_BET_LIST)
  bettingHistoryStore.setBettingHistoryInitProps({ onlyMajorClub: false, fromViewType: FROM_VIEW_TYPE.BUBBLE_BET_LIST })

  return (
    <Fragment>
      <Modal
        popup
        visible={visibleBubbleBetList}
        animated={false}
        css={BubblePopupStyle}
        wrapClassName="bubble-modal"
        className="full-modal message"

        maskClosable={false}
      >

        <BettingListSelectorWrap className='is-bubble-bottom'>
          <div css={PageBgStyle} className="betting-history-bg">
            <img src={BettingHistoryBg} alt="야구선수 배경"/>
          </div>
          <BettingHistoryTab isFullModal={isFullModal}/>
        </BettingListSelectorWrap>

        <div className="bubble-bottom-btn-wrap">
          <span className="bubble-tail"/>
          <Button primary className="bubble-btn" onClick={onCloseHandler}>
            진행중 베팅
            <span className="x-ico"/>
          </Button>
        </div>

      </Modal>
    </Fragment>
  )
}
export default observer(BubbleBetListPopup)
